import React from 'react';
import PropTypes from 'prop-types';
import { LinedHeadingContainer, LinedHeadingText } from '../styles/LinedHeading';

const LinedHeading = props => (
  /** adjustToScrollMargin: temporary solution for scrolling to correct pos. See handleScrollToElement in BrandListPage */
  <LinedHeadingContainer
    adjustToScrollMargin={props.adjustScroll}
    noMargin={props.noMargin}
    noBottomMargin={props.noBottomMargin}
    bgColor={props.bgColor}
  >
    <LinedHeadingText smallestFontSizeBound={props.smallestFontSizeBound} color={props.color}>
      {props.children}
    </LinedHeadingText>
  </LinedHeadingContainer>
);

LinedHeading.defaultProps = {
  noMargin: false,
  noBottomMargin: false,
  adjustScroll: false,
  smallestFontSizeBound: null,
  bgColor: null,
  color: null,
  children: []
};

LinedHeading.propTypes = {
  noMargin: PropTypes.bool,
  noBottomMargin: PropTypes.bool,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  adjustScroll: PropTypes.bool,
  smallestFontSizeBound: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default LinedHeading;



// WEBPACK FOOTER //
// ./src/components/LinedHeading.js